import { t } from 'i18next';

import { AccessPermissions, BasePaths } from 'core/enums';
import { HeaderModalOptions } from 'coreOld/constants';
import { Icon } from 'coreOld/elements';
import { INavItem } from 'coreOld/types';
import { goTo } from 'coreOld/utils';
import { jobListPath } from 'jobs/routes/routePaths';
import { oldMessagesPath } from 'messages/routes/routePaths';
import { oldOrdersPath } from 'orders/routes/routePaths';
import { projectListPath } from 'projects/routes';
import { customerQuoteListPath } from 'quotes/routes/routePaths';
import { supportRequestListPath } from 'support/routes/routePaths';

import { iconStyle } from './navigationStyle';

export const navStructure = (
  isLoggedUser = false,
  openAuthModal: (type: HeaderModalOptions) => void,
  shouldDisplay = true,
  showIcon = true
): INavItem[] => {
  if (!isLoggedUser) {
    return [
      {
        name: t('labelSignIn'),
        onClick: () => openAuthModal(HeaderModalOptions.SIGN_IN),
      },
      {
        name: t('labelCreateAccount'),
        onClick: () => openAuthModal(HeaderModalOptions.SIGN_UP),
      },
    ];
  }

  return [
    {
      name: t('labelProjects'),
      url: projectListPath(),
      icon: showIcon ? <Icon name={Icon.PROJECTS} style={iconStyle} /> : null,
      isTextHidden: true,
      display: shouldDisplay,
    },
    {
      name: t('labelJobs'),
      url: jobListPath(),
      icon: showIcon ? <Icon name={Icon.JOBS} style={iconStyle} /> : null,
      isTextHidden: true,
      display: shouldDisplay,
      matchedPath: BasePaths.JOB,
    },
    {
      name: t('labelQuotes'),
      url: customerQuoteListPath(),
      icon: showIcon ? <Icon name={Icon.QUOTES} style={iconStyle} /> : null,
      isTextHidden: true,
      display: shouldDisplay,
    },
    {
      name: t('labelOrders'),
      onClick: () => goTo(oldOrdersPath()),
      icon: showIcon ? <Icon name={Icon.ORDERS} style={iconStyle} /> : null,
      isTextHidden: true,
      display: shouldDisplay,
    },
    {
      name: t('labelMessages'),
      onClick: () => goTo(oldMessagesPath()),
      icon: showIcon ? <Icon name={Icon.MESSAGES} style={iconStyle} /> : null,
      isTextHidden: true,
      display: shouldDisplay,
    },
    {
      name: t('labelRequests'),
      url: supportRequestListPath(),
      icon: showIcon ? <Icon name={Icon.REQUEST} style={iconStyle} /> : null,
      isTextHidden: true,
      display: shouldDisplay,
      permissions: [AccessPermissions.SUPPORT_REQUEST],
      matchedPath: BasePaths.SUPPORT_REQUEST,
    },
  ];
};
